import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation DeleteChatMessage($id: ID!) {
    deleteChatMessage(id: $id) {
      id
      ... on TextMessage {
        text
      }
    }
  }
`);
